import React, { useContext } from 'react';
import { Visibility } from '@mui/icons-material';

import { ControlWrap } from '../style';
import { SchemaDisplayContext } from '../context';

function ViewTrigger(props) {
  const { id } = props;
  const { node: { onEdit } } = useContext(SchemaDisplayContext);

  return (
    <ControlWrap onClick={() => onEdit(id)}>
      <Visibility />
    </ControlWrap>
  );
}

export default ViewTrigger;
